var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2728 6.5L19 2.22721L17.7272 3.5L19.8272 5.6H7.72668C4.04127 5.6 1.1 8.71575 1.1 12.5V13.4H2.9V12.5C2.9 9.63445 5.10916 7.4 7.72668 7.4H19.8272L17.7272 9.5L19 10.7728L23.2728 6.5ZM22.9 10.6V11.5C22.9 15.2844 19.9581 18.4 16.2722 18.4H4.17279L6.27279 20.5L5 21.7728L0.727207 17.5L5 13.2272L6.27279 14.5L4.17279 16.6H16.2722C18.8905 16.6 21.1 14.3654 21.1 11.5V10.6H22.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.9b92752e545b09b418362290fd9603a2.svg";
export { ForwardRef as ReactComponent };